/** Confere o dígito verificador (Luhn) do número do cartão, ignorando a máscara. */
export function isNumeroCartaoValido(numero: string) {
    const digitos = numero.replace(/\D/g, '')
    if (!digitos) return false

    const soma = [...digitos].reverse().reduce((total, digito, indice) => {
        const valor = Number(digito) * (indice % 2 ? 2 : 1)
        return total + (valor > 9 ? valor - 9 : valor)
    }, 0)
    return soma % 10 === 0
}
